/**
 * Lo que «Agentes IA» (features/agents-engine) exige de la sesión de Sirius para entrar: el módulo de
 * organización `agents-engine` (`public.org_modules`, en el JWT como `orgModules[].key`) y alguno de los ocho
 * accesos `agents_engine_*` (`public.access.name`, en el JWT como `access[]`). Lo usan el menú
 * (`PagesComponent.canAccessAgentsEngine`) y el guard de la ruta (`AgentsEngineModuleGuard`); la feature deriva
 * sus scopes de la misma lista (`features/agents-engine/core/auth/scopes.ts`, `SIRIUS_ACCESS`, que un spec
 * compara con esta). La autoridad sigue siendo la API (`@EngineRoute`).
 */
export const AGENTS_ENGINE_MODULE_KEY = 'agents-engine';

export const AGENTS_ENGINE_ACCESSES = [
  'agents_engine_catalog_read',
  'agents_engine_catalog_write',
  'agents_engine_publish',
  'agents_engine_runs_start',
  'agents_engine_runs_read',
  'agents_engine_approvals_decide',
  'agents_engine_secrets_write',
  'agents_engine_admin',
] as const;

export type AgentsEngineAccess = (typeof AGENTS_ENGINE_ACCESSES)[number];
